export { default } from './CameraInsights';
